import { Avatar, Button, Col, Rate, Row, Tabs } from 'antd'
import React, { useEffect, useState } from 'react'
import call from '../../../assets/images/call.png'
import { IoCall } from "react-icons/io5";
import { IoIosStar } from "react-icons/io";
import map from '../../../assets/images/map.png'
import pin from '../../../assets/images/pin.png'
import tick from '../../../assets/images/tick.png'
import tick2 from '../../../assets/images/tick2.png'
import fallbackImg from '../../../assets/images/fallbackImg.png'
import './style.css'
import BookingForm from '../../../components/BookingForm'
import { getInitials } from '../../../config/utils'
import useBookingApi from '../../../config/hooks/api/booking/useBookingApi'
import { useDispatch, useSelector } from 'react-redux'
import { setAppLoading, setError, setMessage } from '../../../store/common/generalSlice'
import { useNavigate, useParams } from 'react-router-dom'
import { filtersDataFormatter } from '../../../config/utils/FiltersDataFormatter'
import { selectedFiltersValueClear } from '../../../store/common/servicesSlice'
import userLocationRetrieve from '../../../config/utils/UserLocationRetrieve'
import FullPageLoader from '../../../components/FullPageLoader'
import ChatModal from '../Chats/ChatModal'
import ReceivedReviews from '../../ServiceProvider/Reviews/ReceivedReviews';

const Profile = () => {
    const { createBooking, getServiceProviderSelectedServices, getServiceProviderProfileDetail, isLoading } = useBookingApi()
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { userId } = useParams()

    const [selectedFiltersValue, setSelectedFiltersValue] = useState(null);
    const [spServicesData, setSpServicesData] = useState([]);
    const [profileData, setProfileData] = useState({});
    const [services, setServices] = useState([]);
    const [benefits, setBenefits] = useState([]);

    const { selectedFiltersIds } = useSelector(state => state?.services);

    // to set the selectedValues of filter if user is coming from search page to the profile page.
    useEffect(() => {
        if (selectedFiltersIds && Object.keys(selectedFiltersIds)?.length > 0) {
            setSelectedFiltersValue(selectedFiltersIds);
            dispatch(selectedFiltersValueClear())
        }
    }, [selectedFiltersIds])


    // handling both the asyc function calls parallely.
    useEffect(() => {
        const fetchData = async () => {
            try {
                await Promise.all([getServiceProviderDetail(), getProviderProfileData()]);
            } catch (error) {
                dispatch(setError('An error occured'))
            }
        };
        fetchData();
    }, []);

    // a function to get the serviceProvider detail
    const getServiceProviderDetail = async () => {
        const response = await getServiceProviderSelectedServices(userId);
        if (response) {
            if (response?.data?.serviceProviderServices?.length > 0) {
                const data = filtersDataFormatter(response?.data?.serviceProviderServices);
                setSpServicesData(data);
            }
        }
    }

    // a function to fetch the profile Data of a sp.
    const getProviderProfileData = async () => {
        const { latitude, longitude } = await userLocationRetrieve();
        if (latitude) {
            const response = await getServiceProviderProfileDetail(userId, latitude, longitude);
            if (response) {
                if (response?.data?.serviceProvider?.services) {
                    let prefixServices = response?.data?.serviceProvider?.services;
                    let selectedServices = prefixServices?.length > 5 ?
                        prefixServices.slice(0, 5)
                        : prefixServices;
                    setServices(selectedServices)
                }
                if (response?.data?.serviceProvider?.userDetail?.benefits) {
                    let selectedBenefits;
                    try {
                        selectedBenefits = JSON.parse(response?.data?.serviceProvider?.userDetail?.benefits);
                    } catch (error) {
                        selectedBenefits = [];
                    }
                    setBenefits(selectedBenefits)
                }
                setProfileData(response?.data?.serviceProvider)
            }
        }
    }


    const bookingFormDataOrStatusHandler = async (data) => {
        try {
            dispatch(setAppLoading(true))

            const temp = structuredClone(data)
            const payload = {
                ...temp?.fetchedVehicleData,
                ...temp?.location,
                serviceProviderId: userId,
                quote: false,
                ...temp
            }
            payload.vehicleRegistrationNo = data?.fetchedVehicleData?.vehicleRegistrationNumber
            // payload.services = [].concat(...Object.values(temp?.services))
            // payload.services = [18,19,20] //dev env
            payload.services = data?.services //qa env
            payload.year = payload.year + ''

            const keysToDelete = [
                'vehicleRegistrationNumber',
                'id',
                'createdAt',
                'carRegNo',
                'isApproved',
                'status',
                'updatedAt',
                'forgot',
                'fetchedVehicleData',
                'location',
                'userId'
            ]
            for (let i = 0; i < keysToDelete.length; i++) {
                delete payload[keysToDelete[i]]
            }

            const response = await createBooking(payload)
            if (response) {
                dispatch(setAppLoading(false))

                dispatch(setMessage(response?.data?.message))
                navigate('/booking/my-bookings')
            }
        } catch (error) {
            console.log(error)
            dispatch(setAppLoading(false))
        }
    }

    return (
        <Row className='w-full flex flex-col gap-6'>
            {
                isLoading ?
                    <FullPageLoader />
                    :
                    <>
                        {/* section 1 */}
                        <Row className='custom-card-boxshadow w-full h-fit flex justify-end items-start relative rounded-md bg-white'>
                            <img
                                src={profileData?.bannerThumbUrl || fallbackImg}
                                alt="cover photo"
                                className='w-full h-[315px] object-cover object-center'
                            />
                            <div className='sm:w-11/12 w-full flex relative flex-wrap'>
                                <div className='sm:w-48 h-16 w-full ml-2 sm:ml-0'>
                                    <div className='w-32 h-32 sm:w-36 sm:h-36 rounded-full absolute top-[-60px] sm:top-[-80px] z-20 border-2 border-[#fab700] bg-white'>
                                        <Avatar
                                            className='w-full h-full object-contain object-center p-1 rounded-full'
                                            src={profileData?.imageThumbUrl}
                                            alt="avatar"
                                        >
                                            {getInitials(profileData?.userDetail?.businessName)}
                                        </Avatar>
                                    </div>
                                </div>
                                <div className='flex-1 flex-col my-3 flex-wrap justify-between items-start px-2 gap-4 w-full'>
                                    <div className='flex flex-col mb-2'>
                                        <h2 className='text-black heading-3 md:heading-2 text-wrap break-all'>{profileData?.userDetail?.businessName ? profileData?.userDetail?.businessName : '-'}</h2>
                                        <div className='flex gap-2 items-center flex-wrap'>
                                            {
                                                services?.length > 0 ?
                                                    services?.map((service, index) => {
                                                        if (services?.length == 1) {
                                                            return (
                                                                <p key={'service' + index}>
                                                                    {service?.name}
                                                                </p>
                                                            )
                                                        } else {
                                                            return (
                                                                <p key={'service' + index}>
                                                                    {index == services?.length - 1 ? service?.name : service?.name + '  |  '}
                                                                </p>
                                                            )
                                                        }
                                                    })
                                                    : <p>No service available</p>
                                            }
                                        </div>

                                        <div className='my-1'>
                                            <span className='mr-4 font-semibold text-[#02b563]'>{profileData?.noOfBookingCompleted ? profileData?.noOfBookingCompleted : 0} Jobs Completed</span>
                                            <span className='font-semibold text-[#ff4c89]'>{'(' + `${profileData?.distance ? profileData?.distance.toFixed(2) : 0} Miles Away` + ')'}</span>
                                        </div>
                                    </div>

                                    <div className='flex gap-4 flex-wrap'>
                                        <div className='flex items-center gap-1 bg-[#dfdada80] p-2 w-fit rounded-md'>
                                            <span className='font-semibold'>{profileData?.averageRating} / 5</span>
                                            <Rate value={profileData?.averageRating} count={5} disabled></Rate>
                                        </div>
                                        {/* <div className='h-auto px-5 py-2 flex gap-2 items-center justify-center cursor-pointer rounded-md bg-[#feedbf] text-black'>
                                            <div className='rounded-full bg-[#fab700] p-2'>
                                                <IoCall color='white' size={14} />
                                            </div>
                                            <span className=''>Call</span>
                                        </div> */}
                                        <div className='sm:mr-2 mr-0 sm:mb-0 mb-2 py-[5px] px-2 bg-[#feedbf] rounded-md'>
                                            <ChatModal selectedChatMemberData={profileData} headerName={profileData?.userDetail?.businessName} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Row>

                        {/* section 2 */}
                        <Row className='w-full flex rounded-md justify-between gap-4'>
                            <Col lg={15} md={13} sm={24} xs={24} className='flex relative custom-card-boxshadow h-full bg-white rounded-md'>
                                <Tabs
                                    defaultActiveKey="1"
                                    className='w-full px-4 py-2 h-full'
                                    tabBarStyle={{ color: 'yellow' }}
                                    items={
                                        [
                                            {
                                                key: '1',
                                                label: 'About',
                                                children:
                                                    <div className='p-2 flex flex-col gap-3'>
                                                        <div>
                                                            <h3 className='heading-4 font-medium break-all'>About {profileData?.userDetail?.businessName ? profileData?.userDetail?.businessName : '-'}</h3>
                                                            <p>{profileData?.userDetail?.aboutBusiness ? profileData?.userDetail?.aboutBusiness : '-'}</p>
                                                        </div>
                                                        <div className='border border-dashed border-gray-300'></div>
                                                        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 py-1 w-full flex-wrap lg:flex-nowrap items-start'>
                                                            <div className='flex items-start gap-2'>
                                                                <img src={pin} className='w-5 h-5' />
                                                                <span className='text-wrap'>{profileData?.userDetail?.businessLocation ? profileData?.userDetail?.businessLocation : '-'}</span>
                                                            </div>
                                                            <div className='flex gap-2 items-start'>
                                                                <img src={call} className='w-5 h-5' />
                                                                <span className='text-wrap break-all'>{profileData?.userDetail?.businessContact ? profileData?.userDetail?.businessContact : '-'}</span>
                                                            </div>
                                                            <div className='flex items-start gap-2'>
                                                                <img src={map} className='w-5 h-5' />
                                                                <span className='break-all'>{profileData?.userDetail?.website ?
                                                                    <a href={profileData?.userDetail?.website} target='_blank'>
                                                                        {profileData?.userDetail?.website}</a> : '-'}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className='border border-dashed border-gray-300'></div>
                                                        <div>
                                                            <h3 className='heading-4 font-medium'>Active badges</h3>
                                                            <div className='flex gap-4 flex-wrap'>
                                                                {
                                                                    profileData?.badges?.length > 0 ?
                                                                        profileData?.badges?.map((badge) => {
                                                                            return (
                                                                                <div className='flex flex-col w-24 gap-1'>
                                                                                    <div className='w-24 h-24 custom-card-boxshadow rounded-md items-center justify-center p-1'>
                                                                                        <img src={badge?.imageUrl} alt={badge?.name} className='w-full h-full object-contain' onError={(e) => { e.target.style.display = 'none' }} />
                                                                                    </div>
                                                                                    <span>{badge?.name ? badge?.name : '-'}</span>
                                                                                </div>
                                                                            )
                                                                        })
                                                                        :
                                                                        <p>No badge available</p>
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className='border border-dashed border-gray-300'></div>
                                                        <div>
                                                            <h3 className='heading-4 font-medium'>Our Services</h3>
                                                            <Row className='flex gap-3'>
                                                                {
                                                                    services?.length > 0 ?
                                                                        services?.map((service, index) => {
                                                                            return (
                                                                                <Col lg={7} md={7} sm={12} xs={24} className='flex gap-3 items-start w-full my-2' key={'serCol' + index}>
                                                                                    <img src={tick} className='w-4 h-4' />
                                                                                    <span>{service?.name}</span>
                                                                                </Col>
                                                                            )
                                                                        })
                                                                        :
                                                                        <p>-</p>
                                                                }
                                                            </Row>
                                                        </div>
                                                    </div>
                                                ,
                                                className: "",
                                            },
                                            {
                                                key: '2',
                                                label: 'Services',
                                                children:
                                                    <div className='p-2 flex flex-col gap-3'>
                                                        <h3 className='heading-4 font-medium'>Our Services</h3>
                                                        <Row className='flex gap-3'>
                                                            {
                                                                profileData?.services?.length > 0 ?
                                                                    services?.map((service) => {
                                                                        return (
                                                                            <Col lg={7} md={7} sm={11} xs={11} className='flex gap-3 items-center'>
                                                                                <img src={tick} className='w-4 h-4' />
                                                                                <span>{service?.name ? service?.name : '-'}</span>
                                                                            </Col>
                                                                        )
                                                                    })
                                                                    :
                                                                    <p>No services available</p>
                                                            }
                                                        </Row>
                                                    </div>,
                                            },
                                            {
                                                key: '3',
                                                label: 'Benefits',
                                                children:
                                                    <div className='p-2 flex flex-col gap-3'>
                                                        <h3 className='heading-4 font-medium'>Benefits</h3>
                                                        <Row className='flex gap-3'>
                                                            {
                                                                benefits?.length > 0 ?
                                                                    benefits?.map((benefit) => {
                                                                        return (
                                                                            <Col lg={10} md={10} sm={10} xs={11} className='flex gap-3 items-center'>
                                                                                <img src={tick2} className='w-4 h-4' />
                                                                                <span>{benefit}</span>
                                                                            </Col>
                                                                        )
                                                                    })
                                                                    :
                                                                    <p>No benefits available</p>
                                                            }

                                                        </Row>
                                                    </div>
                                                ,
                                            },
                                            {
                                                key: '4',
                                                label: 'Opening Hours',
                                                children:
                                                    <div className='p-2 flex flex-col gap-3'>
                                                        <h3 className='heading-4 font-medium'>Opening hours</h3>

                                                        {
                                                            profileData?.workingDays?.length > 0 ?
                                                                profileData?.workingDays?.map((workingDay) => {
                                                                    return (
                                                                        <Row className='flex gap-3'>
                                                                            <Col lg={7} md={7} sm={7} xs={7}>{workingDay?.day}:</Col>
                                                                            {
                                                                                workingDay?.closed ?
                                                                                    <Col lg={16} md={16} sm={16} xs={16}>
                                                                                        <p className='text-red-500 font-medium'>Closed</p>
                                                                                    </Col>
                                                                                    :
                                                                                    workingDay?.fullDay ?
                                                                                        <Col lg={16} md={16} sm={16} xs={16}>
                                                                                            <p>24 Hours</p>
                                                                                        </Col>
                                                                                        :
                                                                                        <Col lg={16} md={16} sm={16} xs={16}>{workingDay?.startTime} to {workingDay?.endTime}</Col>
                                                                            }
                                                                        </Row>
                                                                    )
                                                                })
                                                                :
                                                                <p>No time available</p>
                                                        }

                                                    </div>,
                                            },
                                        ]
                                    } />
                            </Col>

                            <Col lg={7} md={9} sm={18} xs={24} className='p-3 custom-card-boxshadow bg-black rounded-md w-full mx-auto md:mx-0 h-fit'>
                                <h3 className='heading-4 text-white'>Book Service</h3>
                                <p className='text-white font-light'>Vehicle Registration</p>
                                <div className='w-full py-2 flex flex-col gap-1 mt-5'>
                                    <BookingForm
                                        bookingFormDataOrStatusHandler={bookingFormDataOrStatusHandler}
                                        selectedFiltersValue={selectedFiltersValue}
                                        spServicesData={spServicesData}
                                    />
                                </div>
                            </Col>
                        </Row>

                        {/* section 3 */}
                        <Row className='w-full flex rounded-md bg-white px-2 py-4 flex-col gap-4'>
                            {/* // reviews section commented for now only rating will show */}
                            {/* <Col span={24} className='py-4 px-4 bg-[#f4f4fa] rounded-md '>
                                <div className='flex gap-4'>
                                    <Avatar icon={<UserOutlined />} />
                                    <div className='flex flex-col gap-1'>
                                        <span className='font-semibold'>John Doe</span>
                                        <Rate value={3} count={5} />
                                        <span><span>5 july 24</span> | <span>12:00</span></span>
                                    </div>
                                </div>
                                <div className='w-[92%] mx-auto mt-3'>
                                    <p>Porta corporis nibh. Adipisci maiores dui torquent porttitor wisi necessitatibus lorem perspiciatis repudiandae ad nesciunt deleniti facilisi, est orci libero, aspernatur asperiores ornare aliquip vehicula? Proident? Nobis </p>
                                </div>
                            </Col> */}
                            <Col span={24} className='px-4'>
                                <div className=' flex items-center justify-between w-full'>
                                    <h3 className='heading-4 font-semibold mb-2'>Reviews</h3>
                                    {/* <div className='flex px-4 py-2 bg-[#fab700] gap-2 rounded-md'>
                                        <IoIosStar size={20} color='white' />
                                        <span className='text-white'>Rating</span>
                                    </div> */}
                                </div>
                                <div className='flex items-center'>
                                    <div className='flex items-center gap-1 bg-[#dfdada80] mr-2 p-2 w-fit rounded-md'>
                                        <span className='font-semibold'>{Math.floor(profileData?.averageRating)} / 5</span>
                                        <Rate value={profileData?.averageRating} count={5} disabled></Rate>
                                    </div>
                                    <h6 className='heading-6 font-semibold mb-0 text-slate-500'>Average Rating</h6>
                                </div>
                                <ReceivedReviews title={false} spIdProp={userId} />
                            </Col>
                        </Row>
                    </>

            }

        </Row>
    )
}

export default Profile